(function () {
  'use strict';

  if (window.LFInventoryGuardLoaded) return;
  window.LFInventoryGuardLoaded = true;

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var noticeKey = 'lf-inventory-notice';
  var maxOrderWeightGrams = 3000;
  var allowedClicks = new WeakSet();
  var allowedSubmits = new WeakSet();
  var pendingForms = new WeakSet();
  var redirectToCartAfterBuyNow = false;
  var buyNowRedirectTimer = null;
  var reconciliation = null;
  var cartAlerts = new Map();
  var savedNoticeOnLoad = false;
  var isCartPage = /(?:^|\/)cart\/?$/.test(window.location.pathname);
  var cartValidationPending = { inventory: isCartPage, weight: isCartPage };
  var inventoryVerifications = 0;

  if (window.LFWeightValidationState === 'complete') cartValidationPending.weight = false;
  if (window.LFWeightValidationAlert) {
    cartAlerts.set('weight', { message: window.LFWeightValidationAlert, whatsapp: false });
  }

  function syncCartDataFormLock() {
    var form = document.getElementById('lf-co-main');
    var fields = form && form.querySelector('[data-lf-cart-form-fields]');
    if (!form || !fields) return;

    var hasWarning = ['inventory', 'inventory-native', 'weight'].some(function (key) { return cartAlerts.has(key); });
    var isPending = cartValidationPending.inventory || cartValidationPending.weight;
    var blocked = hasWarning || isPending;
    fields.disabled = blocked;
    form.toggleAttribute('data-lf-cart-blocked', blocked);
    form.setAttribute('aria-disabled', blocked ? 'true' : 'false');

    var notice = form.querySelector('[data-lf-cart-blocked-message]');
    if (notice) {
      notice.hidden = !blocked;
      notice.textContent = hasWarning
        ? 'Formulario bloqueado. Corrija las alertas del carrito antes de diligenciar sus datos.'
        : 'Estamos verificando las existencias y el peso del carrito. El formulario se habilitará cuando la revisión termine.';
    }
  }

  function setCartValidationPending(check, pending) {
    if (!Object.prototype.hasOwnProperty.call(cartValidationPending, check)) return;
    cartValidationPending[check] = pending === true;
    syncCartDataFormLock();
  }

  function readSavedNotice() {
    try {
      var saved = window.sessionStorage.getItem(noticeKey);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      return null;
    }
  }

  function cartFingerprint(cart) {
    return JSON.stringify((cart.items || []).map(function (item) {
      return [String(item.variant_id), String(item.key || ''), Number(item.quantity)];
    }).sort(function (a, b) {
      return (a[0] + ':' + a[1]).localeCompare(b[0] + ':' + b[1]);
    }));
  }

  function clearSavedNotice() {
    try { window.sessionStorage.removeItem(noticeKey); } catch (error) { /* Storage may be disabled. */ }
    savedNoticeOnLoad = false;
  }

  function renderCartAlerts() {
    syncCartDataFormLock();
    var box = document.querySelector('[data-lf-cart-alert]');
    if (!box) return false;

    var messages = box.querySelector('[data-lf-cart-alert-messages]');
    var title = box.querySelector('[data-lf-cart-alert-title]');
    if (!messages || !title) return false;
    var nativeMessage = box.querySelector('[data-error-message]');
    if (!box.hasAttribute('data-default-alert-title')) {
      box.setAttribute('data-default-alert-title', title.textContent);
    }

    var entries = Array.from(cartAlerts.entries()).sort(function (a, b) {
      var priority = { inventory: 0, 'inventory-native': 1, weight: 2 };
      return (priority[a[0]] ?? 3) - (priority[b[0]] ?? 3);
    });
    var signature = JSON.stringify(entries);
    if (!entries.length) {
      var wasExpanded = box.classList.contains('is-expanded');
      var nativeFormErrors = box.querySelector('[data-lf-native-cart-errors]');
      var hasNativeError = (nativeMessage && !nativeMessage.hidden && nativeMessage.textContent.trim()) ||
        (nativeFormErrors && !nativeFormErrors.hidden && nativeFormErrors.textContent.trim());
      title.textContent = box.getAttribute('data-default-alert-title') || title.textContent;
      box.removeAttribute('data-alert-signature');
      messages.replaceChildren();
      if (hasNativeError) {
        box.classList.add('is-expanded');
        if (!wasExpanded) {
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (box.focus) box.focus({ preventScroll: true });
        }
      } else box.classList.remove('is-expanded');
      return true;
    }

    var changed = box.getAttribute('data-alert-signature') !== signature;
    var inventoryMessage = cartAlerts.get('inventory') || cartAlerts.get('inventory-native');
    title.textContent = inventoryMessage && /agotad|ya no tiene existencias|retiramos|sin stock/i.test(inventoryMessage.message)
      ? 'ATENCIÓN: PRODUCTO AGOTADO O RETIRADO DEL CARRITO'
      : inventoryMessage
        ? 'ATENCIÓN: REVISE EL INVENTARIO DEL CARRITO'
        : 'No es posible continuar al pago';
    messages.replaceChildren();
    entries.forEach(function (entry) {
      var paragraph = document.createElement('p');
      paragraph.textContent = entry[1].message;
      messages.appendChild(paragraph);
      if (entry[1].whatsapp) {
        var link = document.createElement('a');
        link.href = 'https://wa.link/3fu7so';
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Solicitar por WhatsApp';
        link.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-height:44px;margin-top:12px;padding:10px 18px;border-radius:5px;background:#fff;color:#0326A5;font-weight:700;text-decoration:underline;';
        messages.appendChild(link);
      }
    });
    box.classList.add('is-expanded');
    box.setAttribute('data-alert-signature', signature);
    if (changed) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (box.focus) box.focus({ preventScroll: true });
    }
    return true;
  }

  function setCartAlert(key, message, withWhatsApp) {
    if (!message) cartAlerts.delete(key);
    else cartAlerts.set(key, { message: message, whatsapp: withWhatsApp === true });
    return renderCartAlerts();
  }

  function clearCartAlert(key) {
    cartAlerts.delete(key);
    return renderCartAlerts();
  }

  function syncNativeCartStockError() {
    var box = document.querySelector('[data-lf-cart-alert]');
    if (!box) return;

    var stockErrorPattern = /suficiente|agotad|sin existencias|inventario|inventory|sold out|not enough/i;
    var nativeNodes = Array.from(box.querySelectorAll('[data-lf-native-cart-errors], [data-error-message]'));
    var stockMessages = [];

    nativeNodes.forEach(function (node) {
      var text = node.textContent.trim().replace(/\s+/g, ' ');
      if (text && stockErrorPattern.test(text)) {
        if (!stockMessages.includes(text)) stockMessages.push(text);
        node.hidden = true;
        node.setAttribute('data-lf-native-stock-captured', 'true');
      } else if (node.hasAttribute('data-lf-native-stock-captured')) {
        node.hidden = false;
        node.removeAttribute('data-lf-native-stock-captured');
      }
    });

    var message = stockMessages.join(' ');
    var current = cartAlerts.get('inventory-native');
    if (message && (!current || current.message !== message)) {
      setCartAlert('inventory-native', message);
    } else if (!message && current) {
      clearCartAlert('inventory-native');
    }
  }

  function showMessage(message, context, withWhatsApp) {
    var host = context && context.closest
      ? context.closest('[data-cart-page], [data-cart-drawer], cart-drawer, product-info')
      : null;
    host = host || document.querySelector('[data-cart-page]') ||
      document.querySelector('[data-cart-drawer]') || document.querySelector('main') || document.body;
    if (host.querySelector('[data-lf-cart-alert]') && setCartAlert('inventory', message, withWhatsApp)) return;
    var box = host.querySelector('[data-lf-inventory-message]');

    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-lf-inventory-message', '');
      box.setAttribute('role', 'alert');
      box.setAttribute('aria-live', 'assertive');
      box.setAttribute('data-lf-inventory-message-box', '');
      box.style.cssText =
        'display:block;margin:16px 0;padding:20px 22px;background:#0326A5;' +
        'border:3px solid #7AC200;border-radius:6px;color:#FFFFFF;' +
        'font-size:22px;line-height:1.45;font-weight:700;' +
        'box-shadow:0 5px 18px rgba(3,38,165,.28);';
      var anchor = host.querySelector('[data-cart-errors-container]') ||
        host.querySelector('[data-cart-drawer-body]') || host.firstElementChild;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
      else host.prepend(box);
    }

    var isOutOfStock = /agotad|sin existencias|no tiene existencias/i.test(message);
    if (isOutOfStock) {
      box.replaceChildren();
      var title = document.createElement('strong');
      title.textContent = 'PRODUCTO AGOTADO';
      title.style.cssText = 'display:block;margin-bottom:5px;color:#FFD600;font-size:1.1em;font-weight:800;';
      var details = document.createElement('span');
      details.textContent = message;
      box.append(title, details);
    } else {
      box.textContent = message;
    }
    if (withWhatsApp) {
      var link = document.createElement('a');
      link.href = 'https://wa.link/3fu7so';
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Solicitar por WhatsApp';
      link.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-height:44px;margin-top:12px;padding:10px 18px;border-radius:5px;background:#FFFFFF;color:#0326A5;font-weight:700;text-decoration:underline;';
      box.appendChild(link);
    }
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearMessage(context) {
    var savedNotice = readSavedNotice();
    if (savedNotice && savedNotice.message) {
      setCartAlert('inventory', savedNotice.message, savedNotice.whatsapp === true);
      return;
    }
    var scope = context || document;
    if (document.querySelector('[data-lf-cart-alert]') && clearCartAlert('inventory')) return;
    scope.querySelectorAll('[data-lf-inventory-message]').forEach(function (box) {
      box.remove();
    });
  }

  window.LFInventoryGuard = {
    setCartAlert: setCartAlert,
    clearCartAlert: clearCartAlert,
    setCartValidationPending: setCartValidationPending
  };

  function endpoint(path) {
    return root + path.replace(/^\//, '');
  }

  function getCart() {
    return fetch(endpoint('cart.js?_=' + Date.now()), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('No fue posible consultar el carrito.');
      return response.json();
    });
  }

  function getVariantState(handle, variantId) {
    if (!handle || !variantId) return Promise.reject(new Error('No se identificó la variante.'));

    var url = endpoint('products/' + encodeURIComponent(handle)) +
      '?section_id=api-live-cart-info&variant=' + encodeURIComponent(variantId) +
      '&_=' + Date.now();

    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('No fue posible consultar el inventario.');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var state = doc.querySelector('[data-lf-inventory-state]');
      var stock = doc.querySelector('[data-max-inventory]');
      if (!state || !stock) throw new Error('La respuesta de inventario no es válida.');

      var rawStock = stock.textContent.trim();
      var tracked = state.getAttribute('data-protected') === 'true';
      var quantity = Number(rawStock);
      if (tracked && (!rawStock || !Number.isFinite(quantity))) {
        throw new Error('No se pudo confirmar el inventario actual.');
      }

      return {
        tracked: tracked,
        title: state.getAttribute('data-product-title') || 'Este producto',
        stock: tracked ? quantity : null,
        weight: Number(state.getAttribute('data-variant-weight'))
      };
    });
  }

  function getProductHandle(form, button) {
    var info = form.closest('[data-product-handle]');
    if (info && info.dataset.productHandle) return info.dataset.productHandle;

    var directHandle = button && button.getAttribute('data-handle');
    if (directHandle) return directHandle;

    var card = form.closest('[data-product-block]');
    var link = card && card.querySelector('a[data-grid-link][href*="/products/"]');
    if (link) {
      var path = new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean);
      var productIndex = path.lastIndexOf('products');
      if (productIndex >= 0) return decodeURIComponent(path[productIndex + 1] || '');
    }

    var action = form.getAttribute('action') || '';
    var actionPath = new URL(action, window.location.origin).pathname.split('/').filter(Boolean);
    var actionProductIndex = actionPath.lastIndexOf('products');
    return actionProductIndex >= 0 ? decodeURIComponent(actionPath[actionProductIndex + 1] || '') : '';
  }

  function cartQuantity(cart, variantId) {
    return cart.items.reduce(function (total, item) {
      return String(item.variant_id) === String(variantId) ? total + item.quantity : total;
    }, 0);
  }

  function requestedQuantity(form) {
    var input = form.querySelector('[name="quantity"]');
    var quantity = input ? Number(input.value) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function blockAdd(form, button, message) {
    pendingForms.delete(form);
    if (button) {
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
    }
    showMessage(message, form);
  }

  function checkAdd(form, button, continueAction) {
    if (pendingForms.has(form)) return;
    pendingForms.add(form);

    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;
    var handle = getProductHandle(form, button);
    if (!variantId || !handle) {
      blockAdd(form, button, 'No pudimos identificar el producto y confirmar sus existencias. No se agregó al carrito.');
      return;
    }

    Promise.all([getVariantState(handle, variantId), getCart()]).then(function (results) {
      var state = results[0];
      var cart = results[1];
      if (!state.tracked) {
        pendingForms.delete(form);
        continueAction();
        return;
      }

      var wanted = cartQuantity(cart, variantId) + requestedQuantity(form);
      if (state.stock >= 5 && wanted <= state.stock) {
        pendingForms.delete(form);
        clearMessage(form);
        continueAction();
        return;
      }

      if (state.stock <= 0) {
        reconcileCart().then(function (result) {
          var suffix = result.changed ? ' Lo retiramos del carrito.' : '';
          blockAdd(form, button, state.title + ' está agotado. No es posible agregarlo ni realizar la compra.' + suffix);
        }).catch(function () {
          blockAdd(form, button, state.title + ' aparece agotado y no pudimos actualizar el carrito. No es posible continuar con la compra.');
        });
        return;
      }

      if (state.stock < 5) {
        pendingForms.delete(form);
        if (button) {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
        }
        showMessage(state.title + ' tiene ' + state.stock + ' unidad(es) disponible(s). Las compras en línea desde 1 hasta 4 unidades se gestionan por WhatsApp; no se agregó al carrito.', form, true);
        return;
      }

      blockAdd(form, button, 'Solo hay ' + state.stock + ' unidad(es) disponibles de ' + state.title + '. Ajuste la cantidad antes de agregarlo.');
    }).catch(function () {
      blockAdd(form, button, 'No pudimos verificar el inventario actual. Por seguridad, no se agregó el producto. Inténtelo de nuevo.');
    });
  }

  function changeLine(key, quantity) {
    return fetch(endpoint('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('No fue posible actualizar el carrito.');
      return response.json();
    }).then(function (cart) {
      if (cart && cart.status) throw new Error(cart.description || 'Shopify rechazó la actualización del carrito.');
      return cart;
    });
  }

  function reconcileCart() {
    if (reconciliation) return reconciliation;

    reconciliation = getCart().then(function (cart) {
      var savedNotice = readSavedNotice();
      if (savedNotice) {
        var currentFingerprint = cartFingerprint(cart);
        if (!savedNotice.cartFingerprint) {
          savedNotice.cartFingerprint = currentFingerprint;
          try { window.sessionStorage.setItem(noticeKey, JSON.stringify(savedNotice)); } catch (error) { /* Storage may be disabled. */ }
        } else if (savedNotice.cartFingerprint !== currentFingerprint) {
          clearSavedNotice();
          cartAlerts.delete('inventory');
          cartAlerts.delete('inventory-native');
          renderCartAlerts();
        }
      }
      var groups = new Map();
      cart.items.forEach(function (line) {
        var key = String(line.variant_id);
        if (!groups.has(key)) groups.set(key, { id: line.variant_id, handle: line.handle, lines: [] });
        groups.get(key).lines.push(line);
      });

      return Promise.all(Array.from(groups.values()).map(function (group) {
        return getVariantState(group.handle, group.id).then(function (state) {
          return { group: group, state: state };
        });
      })).then(function (checked) {
        var changes = [];
        var removedTitles = [];
        var reducedTitles = [];
        var lowStockTitles = [];

        checked.forEach(function (entry) {
          if (!entry.state.tracked) return;
          var remaining = Math.max(0, entry.state.stock);
          if (remaining > 0 && remaining < 5) lowStockTitles.push(entry.state.title);
          entry.group.lines.forEach(function (line) {
            var keep = Math.min(line.quantity, remaining);
            remaining -= keep;
            if (keep !== line.quantity) {
              changes.push({ key: line.key, quantity: keep });
              if (keep === 0) removedTitles.push(entry.state.title);
              else reducedTitles.push(entry.state.title);
            }
          });
        });

        return changes.reduce(function (chain, change) {
          return chain.then(function () { return changeLine(change.key, change.quantity); });
        }, Promise.resolve()).then(function () {
          if (!changes.length && !lowStockTitles.length) return { ok: true, changed: false };

          var parts = [];
          if (removedTitles.length) {
            parts.push('Retiramos del carrito ' + Array.from(new Set(removedTitles)).join(', ') + ' porque ya no tiene existencias.');
          }
          if (reducedTitles.length) {
            parts.push('Ajustamos la cantidad disponible de ' + Array.from(new Set(reducedTitles)).join(', ') + '.');
          }
          if (lowStockTitles.length) {
            parts.push('Compra en línea no disponible para ' + Array.from(new Set(lowStockTitles)).join(', ') + ': quedan entre 1 y 4 unidades y esos pedidos se gestionan por WhatsApp.');
          }
          var message = parts.join(' ');
          var withWhatsApp = lowStockTitles.length > 0;
          if (!changes.length) return { ok: false, changed: false, message: message, whatsapp: withWhatsApp };
          return getCart().then(function (updatedCart) {
            try {
              window.sessionStorage.setItem(noticeKey, JSON.stringify({
                message: message,
                whatsapp: withWhatsApp,
                cartFingerprint: cartFingerprint(updatedCart)
              }));
            } catch (error) { /* Storage may be disabled. */ }
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            return { ok: false, changed: true, message: message, whatsapp: withWhatsApp };
          });
        });
      });
    }).finally(function () {
      reconciliation = null;
    });

    return reconciliation;
  }

  function showSavedNotice() {
    var notice = readSavedNotice();
    if (!notice || !notice.message) return;
    savedNoticeOnLoad = true;
    showMessage(notice.message, null, notice.whatsapp === true);
  }

  function refreshAfterRemoval(result) {
    if (!result.changed) return;
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    } else {
      showMessage(result.message, null, result.whatsapp === true);
    }
  }

  function getWeightForCheckout(cart, button) {
    var cartWeight = Number(cart.total_weight);
    if (!Number.isFinite(cartWeight) || cartWeight < 0) {
      return Promise.reject(new Error('No se pudo confirmar el peso del carrito.'));
    }
    var hasUnweightedPhysicalLine = (cart.items || []).some(function (line) {
      return line.requires_shipping && (!Number.isFinite(Number(line.grams)) || Number(line.grams) <= 0);
    });
    if (hasUnweightedPhysicalLine) {
      return Promise.reject(new Error('Hay productos físicos sin peso válido registrado.'));
    }

    var addForm = button && button.closest
      ? button.closest('form[action*="/cart/add"]')
      : null;
    if (!addForm) return Promise.resolve(cartWeight);

    var variantInput = addForm.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;
    var handle = getProductHandle(addForm, button);
    if (!variantId || !handle) {
      return Promise.reject(new Error('No se pudo identificar el producto para confirmar el peso total.'));
    }

    return getVariantState(handle, variantId).then(function (state) {
      if (!Number.isFinite(state.weight) || state.weight <= 0) {
        throw new Error('No se pudo confirmar el peso de ' + state.title + '.');
      }
      return cartWeight + state.weight * requestedQuantity(addForm);
    });
  }

  function validateWeightBeforeCheckout(button, continueAction, canContinue) {
    getCart().then(function (cart) {
      return getWeightForCheckout(cart, button);
    }).then(function (totalWeight) {
      if (totalWeight > maxOrderWeightGrams) {
        var message = 'El pedido pesa ' + (totalWeight / 1000).toFixed(3) + ' kg y supera el máximo de 3 kg por envío. Reduzca cantidades antes de continuar al pago.';
        if (!setCartAlert('weight', message)) showMessage(message, button);
        return;
      }
      clearCartAlert('weight');
      if (canContinue) {
        clearMessage();
        continueAction();
      }
    }).catch(function () {
      var message = 'No fue posible verificar el peso total del pedido o hay un producto físico sin peso válido. Por seguridad, el pago está bloqueado; revise el peso del producto e inténtelo nuevamente.';
      if (!setCartAlert('weight', message)) showMessage(message, button);
    });
  }

  function validateBeforeCheckout(button, continueAction) {
    reconcileCart().then(function (result) {
      if (result.changed) {
        refreshAfterRemoval(result);
        return;
      }
      var savedNotice = readSavedNotice();
      if (!result.ok) {
        showMessage(savedNotice && savedNotice.message || result.message || 'No fue posible confirmar las existencias. Por seguridad, el pago está bloqueado.', button, savedNotice ? savedNotice.whatsapp === true : result.whatsapp === true);
      } else if (savedNotice && savedNotice.message) {
        showMessage(savedNotice.message, button, savedNotice.whatsapp === true);
      }
      validateWeightBeforeCheckout(button, continueAction, result.ok && !savedNotice);
    }).catch(function () {
      showMessage('No fue posible verificar el inventario actual. Por seguridad, el pago está bloqueado. Revise el carrito e inténtelo nuevamente.');
    });
  }

  function hideAcceleratedCheckout() {
    document.querySelectorAll(
      'form[data-lf-inventory-scope="protected"] .additional-checkout-buttons, ' +
      'form[data-lf-inventory-scope="protected"] [data-additional-checkout-button], ' +
      'form[data-lf-inventory-scope="protected"] .shopify-payment-button, ' +
      'form[data-lf-inventory-scope="protected"] [data-buy-it-now], ' +
      'form[data-lf-inventory-scope="protected"] shopify-accelerated-checkout, ' +
      'form[data-lf-inventory-scope="protected"] shopify-buy-it-now-button'
    ).forEach(function (element) {
      if (element.hidden) return;
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var buyNowToCart = target.closest('[data-lf-buy-now-to-cart]');
    if (buyNowToCart) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var productForm = buyNowToCart.closest('form[action*="/cart/add"]');
      var addButton = productForm && productForm.querySelector(
        'button[name="add"][data-add-to-cart]'
      );

      if (addButton && !addButton.disabled) {
        redirectToCartAfterBuyNow = true;
        window.clearTimeout(buyNowRedirectTimer);
        buyNowRedirectTimer = window.setTimeout(function () {
          redirectToCartAfterBuyNow = false;
        }, 20000);
        addButton.click();
      }
      return;
    }

    var checkout = target.closest(
      'button[name="checkout"], #lf-modal-pay, a[href*="/checkout"], ' +
      '.shopify-payment-button__button, shopify-accelerated-checkout, shopify-buy-it-now-button'
    );
    if (checkout) {
      if (allowedClicks.has(checkout)) {
        allowedClicks.delete(checkout);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      validateBeforeCheckout(checkout, function () {
        var form = checkout.closest('form[action*="/cart"]');
        if (form) allowedSubmits.add(form);
        allowedClicks.add(checkout);
        checkout.click();
      });
      return;
    }

    var addButton = target.closest('button[name="add"], button[data-add-to-cart], [data-upsell-btn]');
    var addForm = addButton && addButton.closest('form[action*="/cart/add"]');
    if (!addButton || !addForm) return;

    if (allowedClicks.has(addButton)) {
      allowedClicks.delete(addButton);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    checkAdd(addForm, addButton, function () {
      allowedClicks.add(addButton);
      addButton.click();
    });
  }, true);

  document.addEventListener('theme:cart:refresh', function () {
    if (!redirectToCartAfterBuyNow) return;

    redirectToCartAfterBuyNow = false;
    window.clearTimeout(buyNowRedirectTimer);
    window.location.href = window.theme && window.theme.routes
      ? window.theme.routes.cart_url
      : root + 'cart';
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (/(?:^|\/)cart\/add(?:\.js)?\/?$/.test(new URL(form.action, window.location.origin).pathname)) {
      if (allowedSubmits.has(form)) {
        allowedSubmits.delete(form);
        return;
      }
      if (pendingForms.has(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      var submitter = event.submitter;
      checkAdd(form, submitter, function () {
        allowedSubmits.add(form);
        if (form.requestSubmit && submitter) form.requestSubmit(submitter);
        else form.submit();
      });
      return;
    }

    if (!/(?:^|\/)cart\/?$/.test(new URL(form.action, window.location.origin).pathname)) return;
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    if (allowedSubmits.has(form)) {
      allowedSubmits.delete(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    validateBeforeCheckout(form, function () {
      allowedSubmits.add(form);
      if (form.requestSubmit) form.requestSubmit(event.submitter);
      else form.submit();
    });
  }, true);

  function verifySavedCart() {
    inventoryVerifications += 1;
    setCartValidationPending('inventory', true);
    reconcileCart().then(function (result) {
      if (result.changed) refreshAfterRemoval(result);
      else if (!result.ok) {
        var savedNotice = readSavedNotice();
        showMessage(savedNotice && savedNotice.message || result.message || 'No fue posible confirmar las existencias actuales. El pago quedará bloqueado hasta revisar el carrito.', null, savedNotice ? savedNotice.whatsapp === true : result.whatsapp === true);
      } else if (readSavedNotice()) {
        showSavedNotice();
      } else {
        savedNoticeOnLoad = false;
        clearMessage();
      }
    }).catch(function () {
      if (isCartPage) {
        setCartAlert('inventory', 'No fue posible verificar las existencias. Por seguridad, corrija o vuelva a cargar el carrito antes de diligenciar el formulario.');
      }
    }).finally(function () {
      inventoryVerifications = Math.max(0, inventoryVerifications - 1);
      setCartValidationPending('inventory', inventoryVerifications > 0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncNativeCartStockError();
    if (window.MutationObserver && document.documentElement) {
      var cartErrorObserver = new MutationObserver(syncNativeCartStockError);
      cartErrorObserver.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
    }
    showSavedNotice();
    hideAcceleratedCheckout();
    verifySavedCart();
  });
  hideAcceleratedCheckout();

  document.addEventListener('theme:cart:open', verifySavedCart);
  document.addEventListener('cart:updated', verifySavedCart);
  document.addEventListener('cart:refresh', verifySavedCart);
  document.addEventListener('theme:cart:refresh', verifySavedCart);
  document.addEventListener('theme:cart:refresh', hideAcceleratedCheckout);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !isCartPage) return;
    setCartValidationPending('inventory', true);
    setCartValidationPending('weight', true);
    document.dispatchEvent(new Event('cart:refresh'));
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') verifySavedCart();
  });
  window.setInterval(function () {
    if (document.visibilityState === 'visible') verifySavedCart();
  }, 5 * 60 * 1000);

  if (document.documentElement && window.MutationObserver) {
    var observer = new MutationObserver(hideAcceleratedCheckout);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
